export default {
  FIRST_ONE: 'firstOne',
  FIRST_THREE: 'firstThree',
  SHOW_INCREMENT_AMOUNT: 'showIncrementAmount',
  SHOW_ALL: 'showAll',
  HIDDEN: 'hidden'
};
